// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"_1Xj0e","menu":"_88LK8","withSeparatorAfter":"kslQN","menuItemSeparator":"_1NUMp","mobileOnly":"p2ki_"};